import React, { Component } from "react";
import PropTypes from "prop-types";
import TextFieldMaterial from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormLabel from "@material-ui/core/FormLabel";
import "./Form.css";
import { withStyles, createMuiTheme } from "@material-ui/core/styles";
import validate from "../../utils/validate";
import purple from "@material-ui/core/colors/purple";
import green from "@material-ui/core/colors/green";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  margin: {
    margin: theme.spacing.unit
  },
  cssLabel: {
    "&$cssFocused": {
      color: purple[500]
    }
  },
  cssFocused: {},
  cssUnderline: {
    "&:after": {
      borderBottomColor: purple[500]
    }
  },
  bootstrapRoot: {
    padding: 0,
    "label + &": {
      marginTop: theme.spacing.unit * 3
    }
  },
  bootstrapError: {
    border: "1px solid red"
  },
  bootstrapInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 12px",
    width: "calc(100% - 24px)",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
    }
  },
  bootstrapFormLabel: {
    fontSize: 18
  }
});

const theme = createMuiTheme({
  palette: {
    primary: green
  }
});

class TextField extends Component {
  state = {
    error: false,
    errorMessage: ""
  };

  componentDidMount() {
    this.validateFn(this.props.value, this.props.required, this.props.regEx);
  }

  componentWillReceiveProps(nextProps) {
    this.validateFn(nextProps.value, nextProps.required, nextProps.regEx);
  }

  handleChange = event => {
    var value = event.target.value;
    if(value[0] === ' ') {
      value = value.trim();
    }
    this.validateFn(value, this.props.required, this.props.regEx);
  };

  validateFn(value, required, regEx) {
    let errorObj = validate(value, required, regEx);
    this.setState(() => errorObj);

    if (this.props.onChanged) {
      this.props.onChanged(value, errorObj.error);
    }
  }

  render() {
    const {
      type,
      label,
      name,
      value,
      placeholder,
      editable,
      required,
      showError,
      classes,
      maxLength,
      multiline,
      helpText,
      positionHelpText,
    } = this.props;
    return (
      <div>
        <FormLabel className="radio-group-label">
          <strong>{label}</strong>
          {this.state.error && showError && positionHelpText==='top'? (
            <span className="error-text">({this.state.errorMessage})</span>
          ) : (
            ""
          )}
        </FormLabel>
        {this.props.helpText !== undefined && positionHelpText==='top' ?
          (<FormHelperText filled={true}>{this.props.helpText}</FormHelperText>) : ""
        }
        <TextFieldMaterial
          type={type}
          name={name}
          value={value}
          placeholder={placeholder}
          multiline={multiline}
          rows={multiline ? 2 : 1}
          onChange={this.handleChange}
          margin="normal"
          style={{ width: "100%" }}
          disabled={!editable}
          required={required}
          error={this.state.error && showError}
          inputProps={{
            maxlength: maxLength
          }}
          InputProps={{
            disableUnderline: true,
            classes: {
              root: classes.bootstrapRoot,
              input: classes.bootstrapInput,
              error: classes.bootstrapError
            }
          }}
        />
        {this.state.error && showError && positionHelpText===undefined ? (
          <span className="error-text">({this.state.errorMessage})</span>
        ) : (
            ""
          )}
        {this.props.helpText !== undefined && positionHelpText===undefined  ?
          (<FormHelperText filled={true}>{this.props.helpText}</FormHelperText>) : ""
        }
      </div>
    );
  }
}

TextField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  editable: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  onChanged: PropTypes.func
};

export default withStyles(styles)(TextField);



// WEBPACK FOOTER //
// ./src/components/form/TextField.js